import React, { useState, useEffect } from 'react'
import {
  Container,
  Grow,
  Grid,
  Paper,
  AppBar,
  TextField,
  Button,
} from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import ChipInput from 'material-ui-chip-input'

import Pagination from '../Pagination'
import Posts from '../Posts/Posts'
import Form from '../Form/Form'

import useStyles from './styles.js'
import { getPosts, getPostsBySearch } from '../../actions/posts'

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const Home = () => {
  const [currentId, setCurrentId] = useState(null)
  const [search, setSearch] = useState('')
  const [tags, setTags] = useState([])
  const dispatch = useDispatch()
  const classes = useStyles()
  const query = useQuery()
  const history = useHistory()
  const page = query.get('page') || 1
  const searchQuery = query.get('searchQuery')

  const searchPost = () => {
    if (search.trim() || tags) {
      dispatch(getPostsBySearch({ search, tags: tags.join(',') }))
      history.push(
        `/posts/search?searchQuery=${search || 'none'}&tags=${tags.join(',')}`
      )
    } else {
      // we  need it?
      history.push('/')
    }
  }

  const handleKeyPress = (e) => {
    if (e.keyCode === 13) {
      searchPost()
    }
  }

  const handleAdd = (tag) => setTags([...tags, tag])

  const handleDelete = (tagOnDelete) =>
    setTags(tags.filter((tag) => tag !== tagOnDelete))

  return (
    <Grow in 
    // style={{color:'blue'}}
    >
      <Container maxWidth="xl">
        <Grid
          container
          className={classes.gridContainer}
          justifyContent="space-between"
          alignItems="stretch"
          spacing={3}
          style={{
            // color
          }}
        >
          <Grid item xs={12} sm={6} md={9}>
            <Posts setCurrentId={setCurrentId} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}
          
          // style={{color:'blue'}}
          >
            <AppBar
              className={classes.appBarSearch}
              position="static"
              color="inherit"
            >
             <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center'
              , fontSize: '20px',
              marginBottom:10,
              // color: ''

             }}>
              Find Volunteering Events
             </div>
              <TextField
                name="search"
                variant="outlined"
                label="Search Events"
                fullWidth
                value={search}
                onKeyPress={handleKeyPress}
                onChange={(e) => setSearch(e.target.value)}
              />
              <ChipInput
                style={{ margin: '10px 0' }}
                value={tags}
                onAdd={handleAdd}
                onDelete={handleDelete}
                label="Search Location"
                variant="outlined"
              />
              <Button
                onClick={searchPost}
                className={classes.searchButton}
                variant="contained"
                color="primary"
              >
                Search
              </Button>
            </AppBar>
            <Form currentId={currentId} setCurrentId={setCurrentId} />
            {!searchQuery && !tags.length && (
              <Paper
                elevation={6}
                style={{
                  marginTop: '15px',
                  padding: '5px 15px',
                  borderRadius: '30px',
                }}
              >
                <Pagination page={page} className={classes.pagination} />
              </Paper>
            )}
          </Grid>
        </Grid>
      </Container>
    </Grow>
  )
}

export default Home
